export enum FileUploadSource {
  DEVICE = 'DEVICE',
  CERTIFICATE = 'CERTIFICATE',
  PREVIOUS_ATTACHMENT = 'PREVIOUS_ATTACHMENT',
}
